import React from 'react';
import { Grid, TextField, Button } from '@mui/material';
import LoadingButton from '@mui/lab/LoadingButton';
import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import { connect } from 'react-redux';
import * as common from '../../appRedux/actions/common';
import * as repair from '../../appRedux/actions/repair';
import * as field from '../../appRedux/actions/field';
import IntlMessages from '../../util/IntlMessages';
import Comeback from '../../components/comeback';
import * as router from '../../constants/router';
import useStyles from './styles';

function TankerFailure(props) {
  const classes = useStyles();
  const onChangeHandler = (data, field) => props.setFields([{ data, field }]);

  return (
    <React.Fragment>
      <Grid container>
        <Grid item xs={6} md={6}>
          <Comeback title={<IntlMessages id="tankerFailure" />} />
        </Grid>
        <Grid item xs={6} md={6} className={classes.gridBtn}>
          <Button
            size="small"
            onClick={() => props.redirectAction(router.TANKER_FAILURE_LIST)}
          >
            <IntlMessages id="listFailure" />
          </Button>
        </Grid>
      </Grid>
      <Grid className={classes.root}>
        <Alert severity="info">
          <AlertTitle>توجه</AlertTitle>
          لطفا کد تانکری که به شما تخصیص داده شده است را وارد کنید.
        </Alert>

        <TextField
          value={props.fuelCarCode}
          onChange={(e) => onChangeHandler(e.target.value, 'fuelCarCode')}
          fullWidth
          autoFocus
          required
          type={'number'}
          margin="normal"
          label={<IntlMessages id="fuelCarCode" />}
          variant="filled"
        />

        <TextField
          value={props.kilometer}
          onChange={(e) => onChangeHandler(e.target.value, 'kilometer')}
          fullWidth
          required
          type={'number'}
          margin="normal"
          label={<IntlMessages id="kilometer" />}
          variant="filled"
        />

        <TextField
          value={props.comment}
          onChange={(e) => onChangeHandler(e.target.value, 'comment')}
          fullWidth
          required
          multiline
          minRows={5}
          margin="normal"
          label={<IntlMessages id="causeOfFailure" />}
          variant="filled"
        />

        <LoadingButton
          onClick={() => props.tankerRepairAddAction()}
          loading={props.loadingBtn}
          variant="contained"
          fullWidth
          size="large"
          color="primary"
        >
          <IntlMessages id="createFailure" />
        </LoadingButton>
      </Grid>
    </React.Fragment>
  );
}

const mapStateToProps = (state) => {
  return {
    comment: state.field.comment,
    loadingBtn: state.common.loadingBtn,
    fuelCarCode: state.field.fuelCarCode,
    kilometer: state.field.kilometer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setFields: (data) => dispatch(field.setFields(data)),
    redirectAction: (data) => dispatch(common.redirectAction(data)),
    tankerRepairAddAction: () => dispatch(repair.tankerRepairAddAction()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TankerFailure);
